import _ from "lodash";

export const ResizableHook = {
  mounted() {
    this.debouncedResize = _.debounce(this.onResize.bind(this), 100);
    this.onResize();
    window.addEventListener("resize", this.debouncedResize);
  },
  updated() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.debouncedResize);
  },
  onResize() {
    const { innerHeight: height, innerWidth: width } = window;
    const { top, left } = this.el.getBoundingClientRect();
    const bottom = this.el.dataset.bottom;
    const right = this.el.dataset.right;

    if (bottom) {
      this.el.style.height = `${height - top - bottom}px`;
    }
    if (right) {
      this.el.style.width = `${width - left - right}px`;
    }
  },
};
